import { render } from "./ClientComprasCargaMasiva.vue?vue&type=template&id=2dbb1ee2&scoped=true"
import script from "./ClientComprasCargaMasiva.vue?vue&type=script&lang=js"
export * from "./ClientComprasCargaMasiva.vue?vue&type=script&lang=js"

import "./ClientComprasCargaMasiva.vue?vue&type=style&index=0&id=2dbb1ee2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbb1ee2"]])

export default __exports__